import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesTemplatesCategoryApiService from '@/modules/settings/services/NomenclaturesTemplatesCategoryApiService';
import {useGetOneNomenclaturesTemplatesCategory} from '@/modules/settings/hooks/useNomenclaturesTemplatesCategory';

const SelectTemplateCategory = ({ value, onChange, filters, ...props }) => {

  const handleChange = useCallback((val) => {
    onChange(val);
  }, [onChange]);

  return (
    <SelectElementCmp
      queryKey={'template-categories-select'}
      filters={filters}
      service={NomenclaturesTemplatesCategoryApiService}
      customMethod={'/ms-core/api/categories/search-categories-subcategories'}
      additionalParams={{type: 'TEMPLATE'}}
      includeValue={''}
      value={typeof value === 'object' ? value?.name : value}
      onChange={handleChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
    />
  );
};

SelectTemplateCategory.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object
};
SelectTemplateCategory.defaultProps = {
  entity: {},
};

export default memo(SelectTemplateCategory);

const CategoryView = ({value}) => {

  const {data} = useGetOneNomenclaturesTemplatesCategory({id: value});

  return (
    <div>
      {data?.data?.name || 'N/A'}
    </div>
  );
};

CategoryView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the Code components in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderTemplateCategory = (text) => {
  return (
    <CategoryView value={text}/>
  );
};
